import React from 'react';
import PropTypes from 'prop-types';
import { Confirm } from 'react-cognito';
import Button from '../Button';
import Link from '../Link';
import { L2, P1, P2 } from '../Typography';

class ConfirmAccountForm extends React.PureComponent {
  static propTypes = {
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func,
    onResend: PropTypes.func,
    error: PropTypes.string,
  };
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {
      error: props.error,
      verificationCode: '',
    };
  }

  onSubmit = e => {
    e.preventDefault();
    this.props.onSubmit(this.state.verificationCode);
  };

  changeVerificationCode = e => {
    this.setState({ verificationCode: e.target.value });
  };

  render() {
    const { onSubmit, onCancel, onResend, error, ...otherProps } = this.props;
    return (
      <div>
        <P1>Check your email for a confirmation code and enter it here.</P1>
        <form onSubmit={this.onSubmit}>
          <label>
            <div>
              <L2>YOUR EMAIL</L2>
            </div>
            <input
              type="text"
              onChange={this.changeVerificationCode}
              required
            />
          </label>

          <div>
            <P1>
              {this.state.error ||
                error ||
                this.state.message || <span>&nbsp;</span>}
            </P1>
          </div>
          <Button type="submit">Confirm</Button>
        </form>
        <P2>
          Don't see an email,{' '}
          <Link onClick={onResend} underline={true}>
            click here
          </Link>{' '}
          to resend it.
        </P2>
      </div>
    );
  }
}

export default props => {
  return (
    <Confirm>
      <ConfirmAccountForm {...props} />
    </Confirm>
  );
};



// WEBPACK FOOTER //
// ./src/components/ConfirmAccountForm/ConfirmAccountForm.js